import React from 'react'

function getHeight(api_id) {
    switch (api_id) {
        case 'yandexcloudtranslate':
        case 'yandexdictionary':
        case 'deeplapi':
        case 'witai':
        case 'abbyycloudocr':
            return 62
        default:
            return 42
    }
}
// data about a provider -- from allIntents
const ProviderLogo = ({ provider: { api_id, logo, title, width } }) => (
    <div className="model-card__logo" title={title}>
        <img
            className="model-card__logo-img"
            width={width}
            height={getHeight(api_id)}
            src={logo}
            alt=""
        />
    </div>
)

export default ProviderLogo



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/ProviderLogo.jsx